import {
  CreateGUFStartRegistrationTask,
  EditGUFStartRegistrationTask,
} from "@nens/brostar/uploadapi-client";

import { addSchema } from "@/helpers/schema-utils";

import { pickGufPrimitiveLibraryFields } from "../guf-schema-primitive-library";

/**
 * Schema for DesignSurfaceInfiltration within a DesignInstallation
 */
export const designSurfaceInfiltrationSchema = addSchema<
  (
    | CreateGUFStartRegistrationTask
    | EditGUFStartRegistrationTask
  )["sourcedocumentData"]["designInstallations"][number]["designSurfaceInfiltrations"]
>({
  type: "array",
  title: "Oppervlakte-infiltraties",
  minItems: 0,
  items: {
    type: "object",
    title: "Oppervlakte-infiltratie",
    required: ["designSurfaceInfiltrationId", "designSurfaceInfiltrationPos"],
    properties: {
      ...pickGufPrimitiveLibraryFields([
        "designSurfaceInfiltrationId",
        "designSurfaceInfiltrationPos",
      ]),
    },
  },
});
